import script from "./APIMerchants.vue?vue&type=script&setup=true&lang=js"
export * from "./APIMerchants.vue?vue&type=script&setup=true&lang=js"

import "./APIMerchants.vue?vue&type=style&index=0&id=42cd400e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\TECHNOVA_FD01\\Desktop\\Augustine\\Projects\\XP\\payout-fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42cd400e"]])

export default __exports__